<template>
    <div class="animated fadeIn">
      <Tables ref="tableGrid"
        :columns="['Período Movimento', 'Categoria Conta Corrente', 'Número Conta Corrente', 'Data Abertura Conta Corrente', 'Usuário Responsável Cadastro', 'Data Implantação Limite Crédito', 'Data Renovação Limite Crédito', 'Data Vencimento Limite Crédito', 'Indicador Cheque Plus', 'Modalidade Conta Corrente', 'Tipo Conta Corrente', 'Situação Conta Corrente', 'Data Ultimo Movimento Conta Corrente', 'Quantidade Dias Utilização ADP', 'Quantidade Dias Utilização Limite Crédito', 'Valor Saldo Bloqueio', 'Valor Saldo Deposito Conta Corrente', 'Valor Saldo Bloqueio Judicial', 'Valor Saldo Devedor ADP', 'Valor Saldo Devedor Limite Crédito', 'Valor Saldo Residual Conta Encerrada']"
        :showTipFooter="false"
        v-on:Load="onLoad">
        <tr v-for="obj in this.objList" v-bind:key="obj.id">
          <TableColumn :IsText="true" :status="1" :value="obj.periodoMovimento" />
          <TableColumn :IsText="true" :status="1" :value="obj.categoriaContaCorrente" />
          <TableColumn :IsText="true" :status="1" :value="obj.numeroContaCorrente" />
          <TableColumn :IsText="true" :status="1" :value="obj.dataAberturaContaCorrente ? formatDate(obj.dataAberturaContaCorrente) : ''" />
          <TableColumn :IsText="true" :status="1" :value="obj.usuarioResponsavelCadastro" />
          <TableColumn :IsText="true" :status="1" :value="obj.dataImplantacaoLimiteCredito ? formatDate(obj.dataImplantacaoLimiteCredito) : ''" />
          <TableColumn :IsText="true" :status="1" :value="obj.dataRenovacaoLimiteCredito ? formatDate(obj.dataRenovacaoLimiteCredito) : ''" />
          <TableColumn :IsText="true" :status="1" :value="obj.dataVencimentoLimiteCredito ? formatDate(obj.dataVencimentoLimiteCredito) : ''" />
          <TableColumn :IsText="true" :status="1" :value="obj.indicadorChequePlus" />
          <TableColumn :IsText="true" :status="1" :value="obj.modalidadeContaCorrente" />
          <TableColumn :IsText="true" :status="1" :value="obj.tipoContaCorrente" />
          <TableColumn :IsText="true" :status="1" :value="obj.situacaoContaCorrente" />
          <TableColumn :IsText="true" :status="1" :value="obj.dataUtimoMovimentoContaCorrente ? formatDate(obj.dataUtimoMovimentoContaCorrente) : ''" />
          <TableColumn :IsText="true" :status="1" :value="obj.quantidadeDiasUtilizacaoADP" />
          <TableColumn :IsText="true" :status="1" :value="obj.quantidadeDiasUtilizacaoLimiteCredito" />
          <TableColumn :IsText="true" :status="1" :value="obj.valorSaldoBloqueio" />
          <TableColumn :IsText="true" :status="1" :value="obj.valorSaldoDepositoContaCorrente" />
          <TableColumn :IsText="true" :status="1" :value="obj.valorSaldoBloqueioJudicial" />
          <TableColumn :IsText="true" :status="1" :value="obj.valorSaldoDevedorADP" />
          <TableColumn :IsText="true" :status="1" :value="obj.valorSaldoDevedorLimiteCredito" />
          <TableColumn :IsText="true" :status="1" :value="obj.valorSaldoResidualContaEncerrada" />
          <!-- <TableColumn :IsText="true" :status="1" :value="obj.dataMatricula ? formatDate(obj.dataMatricula) : ''" />
          <TableColumn :IsText="true" :status="1" :value="obj.situacaoContaCapital" />
          <TableColumn :IsText="true" :status="1" :value="obj.saldoFinalIntegralizadoDiario ? formatValue(obj.saldoFinalIntegralizadoDiario) : 'R$ 0,00'" /> -->
        </tr>
      </Tables>
    </div>
  </template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import ContaCorrenteRepository from '@/shared/http/repositories/business/contacorrente.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'ContaCorrente',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadContaCorrente(this.document)
      }
    },
    onLoadContaCorrente (document) {
      loading.push()
      this.document = document
      ContaCorrenteRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/contacorrente.vue